<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="订单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 订单号:{{ form.no }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdTime" label="申请时间" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%" />
              </el-form-item>
              <span class="viewText" v-else> 申请时间:{{ form.createdTime }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="医生工号" prop="doctorNo" v-if="getIsView()">
                <el-input v-model="form.doctorNo" disabled placeholder="" style="width: 100%" />
              </el-form-item>
              <span class="viewText" v-else> 医生工号:{{ form.doctorNo }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="医生姓名" prop="doctorName" v-if="getIsView()">
                <el-input v-model="form.doctorName" disabled placeholder="" style="width: 100%" />
              </el-form-item>
              <span class="viewText" v-else> 医生姓名:{{ form.doctorName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="医生电话" prop="doctorPhone" v-if="getIsView()">
                <el-input v-model="form.doctorPhone" disabled placeholder="" style="width: 100%" />
              </el-form-item>
              <span class="viewText" v-else> 医生电话:{{ form.doctorPhone }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="stateName" label="订单状态" v-if="getIsView()">
                <el-input disabled v-model="form.stateName"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 订单状态:{{ form.stateName }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="病历号" prop="patientNo" v-if="getIsView()">
                <!-- <el-input v-model="form.patientNo" disabled placeholder="" /> -->
                <el-select v-model="form.patientNo" filterable :filter-method="getPatientDetailList" style="width:100%" @change="patientChange" :disabled="!editMode">
                  <el-option v-for="item in STATIC_PatientDetails" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else> 病历号:{{ form.patientNo }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="患者姓名" prop="patientName" v-if="getIsView()">
                <el-input v-model="form.patientName" disabled placeholder="" />
              </el-form-item>
              <span class="viewText" v-else> 患者姓名:{{ form.patientName }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="床位号" prop="bedNo" v-if="getIsView()">
                <el-input v-model="form.bedNo" disabled placeholder="" />
              </el-form-item>
              <span class="viewText" v-else> 床位号:{{ form.bedNo }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="联系方式" prop="patientPhone" v-if="getIsView()">
                <el-input v-model="form.patientPhone" disabled placeholder="" />
              </el-form-item>
              <span class="viewText" v-else> 联系方式:{{ form.patientPhone }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="科室代码" prop="deptNo" v-if="getIsView()">
                <el-input v-model="form.deptNo" disabled placeholder="" />
              </el-form-item>
              <span class="viewText" v-else> 科室代码:{{ form.deptNo }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="科室名称" prop="deptName" v-if="getIsView()">
                <el-input v-model="form.deptName" disabled placeholder="" />
              </el-form-item>
              <span class="viewText" v-else> 科室名称:{{ form.deptName }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
              </el-form-item>
                 <span class="viewText" v-else> 总数量:{{ form.totalNumber }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
                <el-input disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 总金额:{{ form.totalAmount }}</span>
            </el-col>
            <el-col :span="8" :class="!getIsView()?'viewCol':''">
              <el-form-item label="取货地址" prop="address" v-if="getIsView()">
                <el-input disabled placeholder="取货地址" v-model="form.address"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 取货地址:{{ form.address }}</span>
            </el-col>
            <el-col :span="8" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else> 备注:{{ form.remark }}</span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">订单明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column prop="productName" label="产品" min-width="200">
              <template slot-scope="scope">
                <SelectTable :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'" :innerName="scope.row.productName" :dataList="STATIC_OtherOrderSupplierProducts" @filterMethod="getProductList" @change="(val) => productChange(scope.row, val)" />
              </template>
            </el-table-column>
            <el-table-column label="规格型号" align="center" :show-overflow-tooltip="true" min-width="180" prop="specName"></el-table-column>
            <el-table-column label="生产厂家" align="center" :show-overflow-tooltip="true" min-width="200" prop="manufacturerName"> </el-table-column>
            <el-table-column label="最小单位" align="center" :show-overflow-tooltip="true" min-width="100" prop="minUnit"> </el-table-column>
            <el-table-column label="包装单位" align="center" :show-overflow-tooltip="true" min-width="100" prop="unit"></el-table-column>
            <el-table-column prop="number" label="数量" min-width="130">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" :id="'number' + scope.$index" @input="autoAmount(scope.row)" v-model="scope.row.number"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="采购价" align="center" :show-overflow-tooltip="true" min-width="100" prop="purchasePrice"></el-table-column>
            <el-table-column label="小计" align="center" :show-overflow-tooltip="true" min-width="100" prop="amount"> </el-table-column>
            <el-table-column label="产品注册证" align="center" :show-overflow-tooltip="true" min-width="180" prop="productRegistCertName" />
            <el-table-column label="已配送数量" align="center" :show-overflow-tooltip="true" min-width="100" prop="distributionNumber" />
          </el-table>
        </div>

      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  SaveOtherOrder,
  GetOtherOrderById,
} from "@/api";
import SelectTable from "@/components/select-table";
// import { config } from "@/utils/config";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTable,
  },
  data () {
    return {
      form: {},
      rules: {
        patientNo: [
          { required: true, message: '请选择病历号', trigger: 'blur' }
        ]
      },
      editMode: false,
      showWorkFlowInfo: false,
      childMultiple: false
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getPatientDetailList('')
    this.getProductList('');
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetOtherOrderById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);
      })
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }

        var minusNumberValidate = this.minusNumberValidate(this.form.details);
        if (!minusNumberValidate.flag) {
          this.$my_message(minusNumberValidate.msg, 'warning')
          return;
        }

        SaveOtherOrder(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      console.log(this.userInfo)
      this.form = {
        doctorId: this.userInfo.id,
        doctorName: this.userInfo.name,
        doctorNo: this.userInfo.no,
        doctorPhone: this.userInfo.phone,
        "totalNumber": 0,
        "totalAmount": 0,
        "remark": "",
        "details": [],
        state: 0,
        address: config.OtherOrderAddress,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        ownerDept: this.userInfo.deptId,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      // this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.form.details.push(this.childForm)
      this.autoTotalAmount();
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        "supplierProductId": '',
        "specId": '',
        "brand": "",
        "supplierId": '',
        "manufacturerId": '',
        "unit": "",
        "minUnit": "",
        "stockNumber": 0,
        "number": 0,
        "price": 0,
        distributionNumber: 0,
        "amount": 0,
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();

      this.getProductList('')
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.$index != this.childForm.$index &&
            e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find(
            (e) => e.$index == this.childForm.$index
          );
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    autoAmount (row) {
      row.amount = (row.number * row.price).toFixed(4) * 1;
      this.autoTotalAmount()
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // change event
    patientChange (val) {
      let arr = this.STATIC_PatientDetails.filter(item => item.id == val)[0]
      if (arr) {
        this.form.patientName = arr.name
        this.form.patientId = arr.parentId
        this.form.patientDetailId = arr.id
        this.form.patientNo = arr.no
        this.form.patientPhone = arr.phone
        this.form.deptId = arr.deptId
        this.form.deptName = arr.deptName
        this.form.deptNo = arr.deptNo
        this.form.bedNo = arr.bedNo
      }
    },
    productChange (child, row) {
      let id = child.id
      let arr = this.STATIC_OtherOrderSupplierProducts.filter((item) => item.id == row.id)
      child = Object.assign(child, row)// this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      child.id = id
      child.supplierProductId = row.id
      child.number = 1
      child.price = child.purchasePrice
      child.amount = child.price
      // child.purchasePrice = child.price
      child.undeliveredNumber = child.number
      child.orderNumber = child.number
      child.unCheckedNumber = child.number
      child.remark = ''

      setTimeout(() => {
        document.getElementById("number" + (child.$index - 1)).focus()
        document.getElementById("number" + (child.$index - 1)).select()
      }, 1);
      this.autoTotalAmount();
    },



    getProductList (keyWord) {
      // query.pageSize = 50
      // query.pageIndex = 1
      // query.isEnabled = 1
      // query.deptId = this.form.ownerDept

      this.getOtherOrderSupplierProducts(//query)
        { keyWord: keyWord, pageSize: 50, pageIndex: 1, isEnabled: 1, deptId: this.form.ownerDept })
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
